module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/door/door.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/door/door.mtl
// module id = 476
// module chunks = 0